module.exports = __webpack_public_path__ + "static/media/baby-carriage.3c9af2db.svg";